import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VRow,
        { attrs: { dense: "" } },
        [
          _c(
            VCol,
            { attrs: { sm: "12", lg: "6" } },
            [
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { staticClass: "col-md-3" },
                    [
                      _c(
                        VSubheader,
                        { staticClass: "font-weight-bold p-0" },
                        [_vm._v("User:")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "col-md-9" },
                    [
                      _c(VTextField, {
                        attrs: { dense: "", outlined: "", disabled: "" },
                        model: {
                          value: _vm.record.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.record,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "record.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { sm: "12", lg: "6" } },
            [
              _c(
                VRow,
                { attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { staticClass: "col-md-3" },
                    [
                      _c(
                        VSubheader,
                        { staticClass: "font-weight-bold p-0" },
                        [_vm._v("Groups:")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "col-md-9" },
                    [
                      _vm._l(_vm.record.groups, function (value) {
                        return [
                          _c(
                            VChip,
                            {
                              staticClass: "ml-1",
                              attrs: {
                                small: "",
                                color: value.id ? "success" : "secondary",
                              },
                            },
                            [_vm._v(_vm._s(value.name))]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VTabs,
        [
          _c(VTab, [_vm._v("Datasources")]),
          _c(
            VTabItem,
            [
              _c(VTextField, {
                staticClass: "mt-2",
                attrs: {
                  outlined: "",
                  small: "",
                  dense: "",
                  placeholder: _vm.$t("my_tasks.modals.type_search"),
                  "append-outer-icon": "icon-search",
                },
                model: {
                  value: _vm.filterDatasource,
                  callback: function ($$v) {
                    _vm.filterDatasource = $$v
                  },
                  expression: "filterDatasource",
                },
              }),
              _c(VDataTable, {
                staticClass: "table-inca",
                attrs: {
                  headers: _vm.fieldsTableau,
                  items: _vm.record.datasource,
                  search: _vm.filterDatasource,
                  "hide-default-footer":
                    Object.keys(_vm.record.datasource).length <= 10
                      ? true
                      : false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.actions",
                    fn: function (data) {
                      return [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.right",
                                value: "View permissions",
                                expression: "'View permissions'",
                                modifiers: { hover: true, right: true },
                              },
                            ],
                            attrs: {
                              id: "'popover-button-sync-' + " + data.item.id,
                              size: "sm",
                              variant: "outline-primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.viewPermission(
                                  data.item,
                                  "datasource"
                                )
                              },
                            },
                          },
                          [_c("b-icon-list")],
                          1
                        ),
                        _c(
                          "b-popover",
                          {
                            ref: "popover",
                            attrs: {
                              target:
                                "'popover-button-sync-' + " + data.item.id,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "close",
                                          attrs: { "aria-label": "Close" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onClose(data.item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "d-inline-block",
                                              attrs: { "aria-hidden": "true" },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      ),
                                      _c("span", [_vm._v("Permissions")]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("user-access-permission", {
                              attrs: { permissions: data.item.permissions },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(VTab, [_vm._v("Workbooks")]),
          _c(
            VTabItem,
            [
              _c(VTextField, {
                staticClass: "mt-2",
                attrs: {
                  outlined: "",
                  small: "",
                  dense: "",
                  placeholder: "Type to search",
                  "append-outer-icon": "icon-search",
                },
                scopedSlots: _vm._u([
                  {
                    key: "prepend",
                    fn: function () {
                      return [_c("label", [_vm._v("Filter:")])]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.filterWorkbook,
                  callback: function ($$v) {
                    _vm.filterWorkbook = $$v
                  },
                  expression: "filterWorkbook",
                },
              }),
              _c(VDataTable, {
                attrs: {
                  headers: _vm.fieldsTableau,
                  items: _vm.record.workbook,
                  search: _vm.filterWorkbook,
                  "disable-pagination": "",
                  "hide-default-footer": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.actions",
                    fn: function (data) {
                      return [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.right",
                                value: "View permissions",
                                expression: "'View permissions'",
                                modifiers: { hover: true, right: true },
                              },
                            ],
                            staticClass: "mr-2",
                            attrs: {
                              id: "'popover-button-sync-' + " + data.item.id,
                              size: "sm",
                              variant: "outline-primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.viewPermission(data.item, "workbook")
                              },
                            },
                          },
                          [_c("b-icon-list")],
                          1
                        ),
                        _c(
                          "b-popover",
                          {
                            ref: "popover",
                            attrs: {
                              target:
                                "'popover-button-sync-' + " + data.item.id,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "close",
                                          attrs: { "aria-label": "Close" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onClose(data.item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "d-inline-block",
                                              attrs: { "aria-hidden": "true" },
                                            },
                                            [_vm._v("×")]
                                          ),
                                        ]
                                      ),
                                      _c("span", [_vm._v("Permissions")]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("user-access-permission", {
                              attrs: { permissions: data.item.permissions },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }